import DataMapper from './DataMapper'
import States from '../../models/States'
import StatesRM from '../responsemodel/StatesRM'

export default class StatesDataMapper extends DataMapper<StatesRM, States> {
  map = (rm: StatesRM) => new States(rm.id, rm.name, rm.code, rm.GSTCode, rm.districts)
}
